export const theme = {
  colors: {
    appBg: "#f3f5f8",
    panelBg: "#ffffff",
    sidebarBg: "#e9eef5",
    headerStart: "#0f2f57",
    headerEnd: "#1f4f82",
    primary: "#133b68",
    primarySoft: "#dce6f1",
    accent: "#b08d2f",
    border: "#c8d2de",
    tableHeader: "#e4ebf3",
    text: "#12263f",
    subtext: "#4c5d73",
    mutedText: "#708097",
    overlay: "rgba(18, 38, 63, 0.34)"
  }
};
